import { createFileRoute } from '@tanstack/react-router';
import { InlineDemoPage } from '@pages/inline-demo';

/**
 * Route `/inline-demo` — dünner Wrapper um {@link InlineDemoPage}. Liegt bewusst
 * außerhalb des `_shell`-Gates (wie `/status`), damit die einbettbaren SDK-Dialoge
 * ohne Admin-Auth erreichbar und verifizierbar sind.
 */
export const Route = createFileRoute('/inline-demo')({ component: InlineDemoPage });
